import type { AxiosResponse } from 'axios';

type HeaderVal = string | number | boolean | string[] | null | undefined;

const asHeaderString = (v: HeaderVal): string | undefined => {
    if (v === null || v === undefined) return undefined;
    if (Array.isArray(v)) return v.join(',');
    return String(v);
};

const getHeader = (headers: any, name: string): string | undefined => {
    const lower = name.toLowerCase();

    const direct = headers?.[lower] ?? headers?.[name];
    if (direct !== undefined) return asHeaderString(direct as HeaderVal);

    if (typeof headers?.get === 'function') {
        const got = headers.get(name) ?? headers.get(lower);
        return asHeaderString(got as HeaderVal);
    }

    return undefined;
};

export const getDispositionFilename = (value?: string): string | null => {
    if (!value) return null;

    const utf8 = value.match(/filename\*\s*=\s*UTF-8''([^;]+)/i);
    if (utf8?.[1]) {
        try {
            return decodeURIComponent(utf8[1].trim());
        } catch {
            return utf8[1].trim();
        }
    }

    const quoted = value.match(/filename\s*=\s*"([^"]+)"/i);
    if (quoted?.[1]) return quoted[1].trim();

    const plain = value.match(/filename\s*=\s*([^;]+)/i);
    if (plain?.[1]) return plain[1].trim();

    return null;
};

export const downloadBlob = (blob: Blob, fileName: string) => {
    const url = window.URL.createObjectURL(blob);

    try {
        const a = document.createElement('a');
        a.href = url;
        a.download = fileName;
        a.style.display = 'none';
        document.body.appendChild(a);
        a.click();
        a.remove();
    } finally {
        window.URL.revokeObjectURL(url);
    }
};

export const downloadFromDisposition = (res: AxiosResponse<Blob>, fallbackFileName?: string) => {
    const cd = getHeader(res.headers, 'content-disposition');
    const fileName = getDispositionFilename(cd) ?? fallbackFileName ?? 'download';

    downloadBlob(res.data, fileName);
    return fileName;
};

export const downloadByUrl = (url: string) => {
    const a = document.createElement('a');
    a.href = url;
    a.download = ''; // let server Content-Disposition decide filename
    document.body.appendChild(a);
    a.click();
    a.remove();
};
